var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 18H0V16.2857C0 15.1491 0.460936 14.059 1.28141 13.2553C2.10188 12.4515 3.21468 12 4.375 12H9.625C10.7853 12 11.8981 12.4515 12.7186 13.2553C13.5391 14.059 14 15.1491 14 16.2857V18ZM7 10.2857C6.31056 10.2857 5.62787 10.1527 4.99091 9.89424C4.35395 9.63578 3.7752 9.25696 3.28769 8.77941C2.80018 8.30185 2.41347 7.7349 2.14963 7.11094C1.8858 6.48698 1.75 5.81823 1.75 5.14286C1.75 4.46749 1.8858 3.79873 2.14963 3.17477C2.41347 2.55081 2.80018 1.98387 3.28769 1.50631C3.7752 1.02875 4.35395 0.649929 4.99091 0.391477C5.62787 0.133024 6.31056 -1.00638e-08 7 0C8.39239 2.03247e-08 9.72775 0.541835 10.7123 1.50631C11.6969 2.47078 12.25 3.77889 12.25 5.14286C12.25 6.50683 11.6969 7.81493 10.7123 8.77941C9.72775 9.74388 8.39239 10.2857 7 10.2857Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.77039d8a3d39f6ea37a2ecd03254b0f8.svg";
export { ForwardRef as ReactComponent };